import { useMutation } from '@tanstack/react-query';
import { orpc, useInvalidateRpcQueryFn } from '@/api/rpc/client';

/**
 * What changes when AP answers a split suggestion: the invoice (status, lines
 * and the suggestion itself), the list, the activity feed, and every line's match list, since
 * the suggestion's links are confirmed or removed.
 */
function useInvalidateAfterSplitProposal() {
  return useInvalidateRpcQueryFn((orpc) => [
    orpc.accountsPayable.invoices.get.key(),
    orpc.accountsPayable.invoices.list.key(),
    orpc.accountsPayable.invoices.listChangeLog.key(),
    orpc.core.entityAssociations.list.key(),
  ]);
}

/**
 * Confirm a suggested split of one invoice line. Also refreshes on failure:
 * a suggestion whose charges changed is removed by the server, and the screen
 * must stop showing it.
 */
export function useAcceptLineSplitProposal() {
  const invalidateQueries = useInvalidateAfterSplitProposal();
  return useMutation(
    orpc.accountsPayable.invoices.acceptLineSplitProposal.mutationOptions({
      onSettled: () => {
        invalidateQueries();
      },
    }),
  );
}

/** Dismiss a suggested split of one invoice line. */
export function useDismissLineSplitProposal() {
  const invalidateQueries = useInvalidateAfterSplitProposal();
  return useMutation(
    orpc.accountsPayable.invoices.dismissLineSplitProposal.mutationOptions({
      onSettled: () => {
        invalidateQueries();
      },
    }),
  );
}
